"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.styles = exports.default = void 0;
var _react = require("@emotion/react");
function _EMOTION_STRINGIFIED_CSS_ERROR__() { return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop)."; }
var _ref = process.env.NODE_ENV === "production" ? {
  name: "1yc9uo8",
  styles: "overflow-wrap:break-word"
} : {
  name: "23r345-setWordBreak",
  styles: "overflow-wrap:break-word;label:setWordBreak;",
  toString: _EMOTION_STRINGIFIED_CSS_ERROR__
};
const styles = exports.styles = {
  default: (theme, color) => /*#__PURE__*/(0, _react.css)({
    fontSize: '16px',
    color: color ? color : theme.defaultText
  }, process.env.NODE_ENV === "production" ? "" : ";label:default;"),
  paragraph: process.env.NODE_ENV === "production" ? {
    name: "ti75j2",
    styles: "margin:0"
  } : {
    name: "174a9lt-paragraph",
    styles: "margin:0;label:paragraph;",
    toString: _EMOTION_STRINGIFIED_CSS_ERROR__
  },
  intro: process.env.NODE_ENV === "production" ? {
    name: "1kvnwqk",
    styles: "font-size:22px"
  } : {
    name: "uvrfec-intro",
    styles: "font-size:22px;label:intro;",
    toString: _EMOTION_STRINGIFIED_CSS_ERROR__
  },
  small: process.env.NODE_ENV === "production" ? {
    name: "mmdt3g",
    styles: "font-size:14px"
  } : {
    name: "g50f1t-small",
    styles: "font-size:14px;label:small;",
    toString: _EMOTION_STRINGIFIED_CSS_ERROR__
  },
  extrasmall: process.env.NODE_ENV === "production" ? {
    name: "rnnx2x",
    styles: "font-size:12px"
  } : {
    name: "1qg05pr-extrasmall",
    styles: "font-size:12px;label:extrasmall;",
    toString: _EMOTION_STRINGIFIED_CSS_ERROR__
  },
  bold: process.env.NODE_ENV === "production" ? {
    name: "1efi8gv",
    styles: "font-weight:bold"
  } : {
    name: "138uarv-bold",
    styles: "font-weight:bold;label:bold;",
    toString: _EMOTION_STRINGIFIED_CSS_ERROR__
  },
  semiBold: process.env.NODE_ENV === "production" ? {
    name: "16ceglb",
    styles: "font-weight:600"
  } : {
    name: "1spfyku-semiBold",
    styles: "font-weight:600;label:semiBold;",
    toString: _EMOTION_STRINGIFIED_CSS_ERROR__
  },
  size: size => /*#__PURE__*/(0, _react.css)("font-size:", size, ";" + (process.env.NODE_ENV === "production" ? "" : ";label:size;")),
  subtle: theme => /*#__PURE__*/(0, _react.css)({
    color: theme.subtleText
  }, process.env.NODE_ENV === "production" ? "" : ";label:subtle;"),
  setColor: color => /*#__PURE__*/(0, _react.css)({
    color: color
  }, process.env.NODE_ENV === "production" ? "" : ";label:setColor;"),
  italic: process.env.NODE_ENV === "production" ? {
    name: "1jwcxx3",
    styles: "font-style:italic"
  } : {
    name: "2acfoi-italic",
    styles: "font-style:italic;label:italic;",
    toString: _EMOTION_STRINGIFIED_CSS_ERROR__
  },
  align: align => /*#__PURE__*/(0, _react.css)("text-align:", align, ";" + (process.env.NODE_ENV === "production" ? "" : ";label:align;")),
  setWordBreak: value => value === 'break-word' ? _ref : /*#__PURE__*/(0, _react.css)("word-break:", value, ";" + (process.env.NODE_ENV === "production" ? "" : ";label:setWordBreak;")),
  setWhiteSpace: value => /*#__PURE__*/(0, _react.css)("white-space:", value, ";" + (process.env.NODE_ENV === "production" ? "" : ";label:setWhiteSpace;")),
  setLineClamp: lines => /*#__PURE__*/(0, _react.css)("display:-webkit-box;-webkit-line-clamp:", lines, ";-webkit-box-orient:vertical;overflow:hidden;text-overflow:ellipsis;" + (process.env.NODE_ENV === "production" ? "" : ";label:setLineClamp;"))
};
var _default = exports.default = styles;